<template>
  <div class="view-body">
      <div class="view-data">
        <div class="view-data__header">
          <h1>{{title}}</h1>
        </div>
        <div class="form form--password">
          <div class="alert alert-success" v-if="changed">
            Hasło zostało ustawione
          </div>
          <div class="alert alert-danger" v-if="notExist">
            Użytkownik dla którego chcesz utworzyć hasło nie istnieje
          </div>
          <form v-if="!changed" @submit.prevent="submit">
            <div class="row">
              <div class="col">
                <div class="form-group login-input" :class="{ 'input-error': $v.password1.$error || notSamePasswords || weekPassword }">
                  <label>Nowe hasło*</label>
                  <input class="form-control form-control-lg" type="password" v-model="password1"/>
                  <labelInfo v-if="!$v.password2.isTheSame" type="error" message="Wprowadzone hasła nie są jednakowe"/>
                  <labelInfo v-if="!$v.password1.minLength || !$v.password1.required || !$v.password1.isStrange" type="error" message="Nowe hasło jest zbyt słabe. Hasło musi zawierać minimum 10 znaków, w tym: 1 wielką literę, 1 małą literę, 1 cyfrę i 1 znak specjalny."/>
                </div>
                <div class="form-group login-input" :class="{ 'input-error': $v.password2.$error}">
                  <label>Powtórz hasło*</label>
                  <input class="form-control form-control-lg" type="password" v-model="password2"/>
                  <labelInfo v-if="!$v.password2.isTheSame" type="error" message="Wprowadzone hasła nie są jednakowe"/>
                  <labelInfo v-if="!$v.password2.required || !$v.password2.minLength" type="error" message="Nowe hasło jest zbyt słabe. Hasło musi zawierać minimum 10 znaków, w tym: 1 wielką literę, 1 małą literę, 1 cyfrę i 1 znak specjalny."/>
                </div>
              </div>
              <div class="form-footer form-footer--single">
                <p class="form-footer__paragraph">*pola wymagane</p>
                <button class="button-normal button-normal--media">Zapisz</button>
              </div>
            </div>
          </form>
        </div>
      </div>
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import labelInfo from '@/components/blocks/labelInfo.vue'

export default {
  name: 'UserPassword',
  components:{

    labelInfo,

  },
  mixins: [validationMixin],
  data () {
    return {
    
        title: 'Utwórz hasło',

        password1:'',
        password2: '',

        invalid: false,
        changed: false,

        notSamePasswords: false,
        notExist: false,
        weekPassword: false,

    }
  },
  validations: {

    password1: {

      required,
      minLength: minLength(10),
      isStrange(){ return this.isStrange() }

    },
    password2: {

      required,
      minLength: minLength(10),
      isTheSame(){ return this.isTheSame() }

    },
  },
  methods:{

    isStrange(){

      const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})");

      if ( this.password1 ) {

        // if(/[A-Z]/.test(this.password1) && /[!-\/:-@[-`{-~]/.test(this.password1)) {

        if(strongRegex.test(this.password1)) {

          return true;

        }else {

          return false;

        }
      }else{

        return false;

      }

    },

    isTheSame(){

      if ( this.password1 ) {
        if ( this.password1 === this.password2 ) {
            return true;
          } else {
            return false;
          }
      }else{
        return false;
      }

    },

    submit(){

      this.$v.$touch();

        if(!this.$v.$invalid){

            let pass = {
                confirmationToken: this.$route.query.token,
                plainPassword: {
                    first: this.password1,
                    second: this.password2,
                }
            }

            this.$http.put('/users/set/password', pass, {
              headers: {

              'Content-Type': 'application/json'

              }}).
              then(response => {

                this.changed = true;

                let data = {
                  'username': response.data.email,
                  'password': this.password2
                }

                this.$http.post('login_check', data).then(response => {

                localStorage.setItem('auth_token', response.data.token);
                localStorage.setItem('refresh_token', response.data.refresh_token);

                if (localStorage.getItem('auth_token') != null){

                  let user = JSON.stringify(response.data.data.user);
                  let role = response.data.data.user.roles[0];

                  localStorage.setItem('user', user);
                  localStorage.setItem('role', role);

                  if(this.$route.params.nextUrl == null){

                    this.$router.push('/dashboard');
                    this.$router.go();

                  }

                }

                }).catch(error => {

                  console.error(error.response);

                  if(error.response.status === 400){
                    this.notExist = true;
                  }
                  
                })

              })
              .catch(error => {

                  console.error(error.response);

                  if(error.response.status === 400){
                    this.notExist = true;
                  }

              })

        }else{

            this.invalid = true;

        }

    },

  },
};
</script>

<style lang="scss" scoped>

.form{
  width:40%;
  padding: 10px;
}

.list-group--form{
  max-height: 150px;
  width:92%;
  overflow: hidden;
  overflow-y: scroll;
  position: absolute;
}

.form-footer{
  display:flex;
  justify-content: space-between;
  width:100%;
}

.sub-markets-display{
  display:flex;
  overflow:hidden;
  position: relative;

  &__body{
    display:flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height: 150%;
    overflow:hidden;
    overflow-x: scroll;
    white-space: nowrap;

    & ul{
      padding: 0;
      margin:0;
      position: relative;
    }

    & li{
      display: inline-block;
    }
  }
}

</style>
